
export default{
    data() {
        return {
            mobile: null,
            mobileNav: null,
            windowWidth: null,
        }   
    },
    created(){
        window.addEventListener("resize", this.checkScreen);
        this.checkScreen();
        window.addEventListener("resize", this.onResize);
    },
    destroyed() {
        window.removeEventListener("resize", this.onResize);
    },
    methods: {
        checkScreen(){
            this.windowWidth = window.innerWidth;
            if (this.windowWidth <= 860){
                this.mobile = true;
                return;
            }
            this.mobile = false;
            this.mobileNav = false;
        },
        toggleMobileNav(){
            this.mobileNav = !this.mobileNav;
        },
        // eslint-disable-next-line no-unused-vars
        onResize(e) {
            this.$store.commit('changeScreenSizeW', window.innerWidth)
            this.$store.commit('changeScreenSizeH', window.innerHeight)
        },
    }
}
